// extracted by mini-css-extract-plugin
module.exports = {"dimensions":"Dimensions__dimensions___1FUeB"};